import React from 'react';
import { Alert } from '@guildeducationinc/recess';
import { toast } from 'react-toastify';
import styles from './BookmarkToast.module.scss';

interface BookmarkToastProps {
	offeringId: string;
	action?: string;
	undo?: () => Promise<void>;
}

export const BookmarkToast: React.FC<BookmarkToastProps> = ({ action, undo }) => {
	return (
		<Alert display={true} hideClose={true} type='info'>
			<div className={styles.alertContent}>
				<Alert.Content>Bookmark {action === 'remove' ? 'removed' : 'added'}!</Alert.Content>
				<Alert.Action className={styles.alertAction} onClick={undo} testid='bookmark-toast-button'>
					Undo
				</Alert.Action>
			</div>
		</Alert>
	);
};

export const showToast = (
	offeringId: string,
	action?: string,
	undo?: (offeringId: string) => Promise<void>
) => {
	const toastId = 'bookmarked';
	// Wait for the previous toast to animate out
	toast.dismiss();

	const undoAndDismiss = async () => {
		await undo(offeringId);
		toast.dismiss('bookmarked');
	};

	const content = <BookmarkToast action={action} offeringId={offeringId} undo={undoAndDismiss} />;

	setTimeout(() => {
		toast(content, {
			toastId,
			type: 'info',
		});
	}, 0);
};
